module.exports = __webpack_public_path__ + "static/img/S__27795679.a4554f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/S__27795679.jpg
// module id = BZVR
// module chunks = 1